<template>
    <a
       href=""
       ref="showBrightcoveVideo"
       @click.prevent="openBrightcoveVideoModal"
       @keydown.enter="openBrightcoveVideoModal"
       tabindex="0"
       :aria-label="linkAriaLabel">
        {{ linkText }}
    </a>

    <modal ref="brightcoveVideoModal"
           idKey="brightcoveVideo"
           :title="modalTitle"
           :returnFocusTo="showBrightcoveVideo"
           customStyles="--bs-modal-width: 1000px;"
           @closed="onBrightcoveVideoModalClosed">
        <div class="row mt-4 mb-4">
            <BrightcoveVideo
                v-if="isVideoModalVisible"
                :accountId="accountId"
                :videoId="videoId"
                :ariaLabel="modalVideoAriaLabel" />
        </div>
    </modal>
</template>

<script setup lang="ts">
    import { ref } from "vue";
    import BrightcoveVideo from "@/guiide/components/common/BrightcoveVideo.vue";
    import Modal from "@/guiide/components/common/Modal.vue";

    const props = defineProps({
        accountId: { type: String, required: true },
        videoId: { type: String, required: true },
        linkText: { type: String, required: true },
        linkAriaLabel: { type: String, required: true },
        modalVideoAriaLabel: { type: String, required: true },
        modalTitle: { type: String, required: true }
    });

    const brightcoveVideoModal = ref<HTMLElement>(null);
    const showBrightcoveVideo = ref<HTMLElement>(null);
    const isVideoModalVisible = ref(false);

    function openBrightcoveVideoModal() {
        isVideoModalVisible.value = true;
        brightcoveVideoModal.value.showModal();
    }

    function onBrightcoveVideoModalClosed() {
        isVideoModalVisible.value = false;
    }
</script>

<style scoped lang="css">
    a:hover {
        cursor: pointer;
    }
</style>
